export const ENTERPRISE_COPY = {
  login: {
    cardTitle: '欢迎来到 AI Vid',
    slogan: '一站式 AI 创作平台',
    title: '企业登录',
    methodTitle: '选择登录方式',
    enterpriseIdPlaceholder: '企业标识',
    enterpriseIdRequired: '请输入企业标识。',
    memberNotFound: '暂未加入该团队，无法登陆。请联系团队管理员获取邀请链接',
    memberPending: '加入团队申请已发送，请耐心等待团队管理员审批',
    codeInvalid: '错误的企业标识，请重新输入',
  },
  meta: {
    login: {
      title: '企业登录',
      description: '登录企业工作区，继续创作和管理资产。',
    },
  },
  teamInvite: {
    applyNow: '立即申请',
    logout: '退出登录',
    needLogoutTitle: '请先退出登录',
    needLogoutDescription: '你当前处于团队空间，请先退出登录后再申请加入新团队。',
  },
  model: {
    // Q3_A（Seedance 2.0）在创作页模型选择下拉项中的名称与描述
    q3aName: 'Seedance 2.0',
    q3aDescription: '电影级画质，细节丰富',
    // Q3_HH（Happyhorse 1.0）在创作页模型选择下拉项中的名称与描述
    q3bName: 'Happyhorse 1.0',
    q3bDescription: '真实感、一致性',
  },
  teamProfile: {
    // 团队空间设置页中显示名称的标题（定制版改为「团队名称」）
    displayNameTitle: '团队名称',
  },
} as const;
